// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"378ae62f","703":"5bfb6906","787":"4dfb4c0c"}[chunkId] + ".chunk.js";
};